import React, { ReactNode } from "react";
import classes from "./Form.module.scss";

interface FormProps {
    header?: string;
    children: ReactNode;
    className?: string;
}

const Form: React.FC<FormProps> = ({ header, children, className }) => {
    return (
        <div className={`${classes.form_container} ${className}`}>
            {header && <h3 className={classes.form_header}>{header}</h3>}
            <form className={classes.form_body}>{children}</form>
        </div>
    );
};

export default Form;
